export const TABS = {
    OBJECT: 0,
    PROJECT: 1,
}